import { render, staticRenderFns } from "./d-books-search-number-results.vue?vue&type=template&id=71ab2f06&scoped=true&"
import script from "./d-books-search-number-results.vue?vue&type=script&lang=js&"
export * from "./d-books-search-number-results.vue?vue&type=script&lang=js&"
import style0 from "./d-books-search-number-results.vue?vue&type=style&index=0&id=71ab2f06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ab2f06",
  null
  
)

export default component.exports